exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".password-successfully-reset-content{text-align:center;width:72%;margin:0 auto}.password-successfully-reset-content .icon{font-size:72px;line-height:72px;margin-bottom:24px;color:#52c41a}.password-successfully-reset-content .title{font-size:24px;color:#4f4f4f;font-weight:500;line-height:32px;margin-bottom:16px}.account-successfully-register-content{text-align:center;width:72%;margin:0 auto}.account-successfully-register-content .icon{font-size:72px;line-height:72px;margin-bottom:24px;color:#fc0}.account-successfully-register-content .title{font-size:24px;color:#4f4f4f;font-weight:500;line-height:32px;margin-bottom:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/forgotPassword.scss
// module id = 2162
// module chunks = 43